// libraries
import React from 'react';
import PropTypes from 'prop-types';
import {map, findIndex} from 'lodash';

// auth/eligibility
import SchoolList from './school-list';

// shared
import Dropdown from 'shared/components/dropdown';
import Label from 'shared/components/label';

export default class Eligibility extends React.Component {
  static propTypes = {
    getCountries: PropTypes.func.isRequired,
    getCities: PropTypes.func.isRequired,
    getSchools: PropTypes.func.isRequired,
    countries: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      code: PropTypes.string
    })).isRequired,
    cities: PropTypes.object.isRequired,
    schools: PropTypes.array.isRequired,
    setNavigationAnnouncement: PropTypes.func.isRequired,
    saveUrlParameters: PropTypes.func.isRequired
  }

  state = {
    country: '',
    city: ''
  }

  componentDidMount() {
    this.props.setNavigationAnnouncement('Check Eligibility');
    this.props.getCountries();
    this.props.saveUrlParameters();
  }

  formattedCountries = () => (
    map(this.props.countries, (country) => ({
      _id: country.name,
      value: country.code,
      text: country.name
    }))
  );

  formattedCities = () => (
    map(this.props.cities.cities, (city) => ({
      _id: city,
      value: city,
      text: city
    }))
  );

  render() {
    const {
      getCities,
      getSchools,
      schools
    } = this.props;

    const {
      country,
      city
    } = this.state;

    const countryOptions = this.formattedCountries();
    const cityOptions = this.formattedCities();

    return (
      <div className="auth-eligibility">
        <h1 className="auth-eligibility-header">Check High School Eligibility</h1>
        <p className="auth-eligibility-text">
          Select a country and city to view<br /> eligible schools.
        </p>
        <legend className="shared-required-legend"></legend>
        <Label autoId="auth-eligibility-country" required>
          Eligible Countries
          <Dropdown
            options={countryOptions}
            onSelect={({value}) => {
              getCities(value);
              this.setState({country: value});
            }}
            value={country}
          />
        </Label>
        <Label autoId="auth-eligibility-city" required>
          Eligible Cities
          <Dropdown
            options={cityOptions}
            onSelect={({value}) => {
              const index = findIndex(countryOptions, {value: country});
              getSchools(countryOptions[index].value, value);
              this.setState({city: value});
            }}
            disabled={!country}
            value={city}
          />
        </Label>
        <SchoolList schools={schools} />
        <a
          className="auth-shared-link center"
          href="https://help.raise.me/hc/en-us/articles/360003494493"
        >Can&#39;t find your high school?
        </a>
      </div>
    );
  }
}
